/* istanbul ignore file */
import { Flex } from 'components/base/layout-components';
import * as TrackingService from 'common/services/tracking.service';
import TreeTeamsDropdown from 'components/teams/TreeTeamsDropdown/TreeTeamsDropdown';
import Header from './Header';
import Text from 'components/base/Text';
import Footer from './Footer';
import Dropdown from 'components/base/Dropdown';
import styled from 'styled-components';
import {
  ALL_ACCOUNTS_TYPES_OPTIONS,
  TRACKING
} from 'common/constants/constants';
import { allTeams } from 'connected-components/TopBar/TopBar.service';
import { getInputField } from './InviteUser.service';
import validator from 'validator';
import useInviteUser from './useInviteUser';

const StyledDiv = styled.div`
  box-sizing: content-box;
  padding-top: 0.7rem;
  .MuiInputBase-root {
    width: 25rem;
    height: 2rem;
  }
  .MuiSelect-select {
    width: 25rem !important;
  }
`;

const FieldsContainer = styled.div`
  box-sizing: content-box;
  width: 25rem;
`;

const InviteUser = () => {
  const {
    accountTypeId,
    setAccountTypeId,
    selectedTeamIds,
    name,
    setName,
    email,
    setEmail,
    isSendInviteDisabled,
    isAdmin,
    onTeamDropdownChange,
    onSendInvite,
    treeTeams,
    isAllTeamsGroup,
    allTeamsGroupId
  } = useInviteUser();

  return (
    <Flex direction='column'>
      <Header />
      <Flex direction='column' pt='medium'>
        <FieldsContainer>
          {getInputField({
            name: 'NAME',
            value: name,
            onChange: e => setName(e.target.value)
          })}
          {getInputField({
            name: 'EMAIL',
            value: email,
            onChange: e => setEmail(e.target.value),
            validationMessage:
              email.trim() !== '' && !validator.isEmail(email)
                ? 'Email is not valid'
                : null
          })}
        </FieldsContainer>
        <Text pb='0.7rem' color='shuttleGray'>
          USER ROLE
        </Text>
        <StyledDiv>
          <Dropdown
            options={ALL_ACCOUNTS_TYPES_OPTIONS}
            selectedValue={accountTypeId}
            onChange={e => setAccountTypeId(e)}
            dataCy='invite-user-role-picker'
          />
        </StyledDiv>
      </Flex>
      <Flex direction='column' pt='x-medium' pb='medium'>
        <Text pb='0.7rem' color='shuttleGray'>
          USER TEAMS
        </Text>
        <TreeTeamsDropdown
          multiple={true}
          selectedTeamIds={
            isAdmin && !isAllTeamsGroup ? [allTeams.id] : selectedTeamIds
          }
          onChange={selectedTeams => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.SETTINGS,
              page_tab: TRACKING.CLICK.RBAC.SETTINGS.INVITE_USER,
              click_type:
                TRACKING.CLICK.RBAC.SETTINGS.DROPDOWN.SELECT_USER_TEAMS_SCOPE
            });
            onTeamDropdownChange(selectedTeams);
          }}
          isDisableChildrenOfSelectedParent={true}
          disabledTeamIds={
            isAdmin
              ? treeTeams
                  .filter(({ id }) => id !== allTeamsGroupId)
                  .map(({ id }) => id)
              : []
          }
          isHideAllContributors={true}
          dataCyPrefix='invite-user'
        />
      </Flex>
      <Footer
        isSendInviteDisabled={isSendInviteDisabled}
        onSendInvite={onSendInvite}
      />
    </Flex>
  );
};

export default InviteUser;
